import request from '@/utils/request'

// 查询维护记录列表
export function listEquipmentMaintenance(query) {
  return request({
    url: '/system/equipment-maintenance/list',
    method: 'get',
    params: query,
  })
}

// 查询维护记录分页
export function pageEquipmentMaintenance(query) {
  return request({
    url: '/system/equipment-maintenance/page',
    method: 'get',
    params: query,
  })
}

// 查询维护记录详细
export function getEquipmentMaintenance(data) {
  return request({
    url: '/system/equipment-maintenance/detail',
    method: 'get',
    params: data,
  })
}

// 新增维护记录
export function addEquipmentMaintenance(data) {
  return request({
    url: '/system/equipment-maintenance/add',
    method: 'post',
    data: data,
  })
}

// 修改维护记录
export function updateEquipmentMaintenance(data) {
  return request({
    url: '/system/equipment-maintenance/edit',
    method: 'post',
    data: data,
  })
}

// 删除维护记录
export function delEquipmentMaintenance(data) {
  return request({
    url: '/system/equipment-maintenance/delete',
    method: 'post',
    data: data,
  })
}
